/*
 * Digital Purchase Order
 *
 * Copyright (c) 2018 LeBog Software GmbH, Germany.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are not permitted.
 */
//@flow

import 'script-loader!./node_modules/jquery/dist/jquery.min.js'
if (DEVELOPMENT) {
    require('script-loader!./node_modules/jquery-migrate/dist/jquery-migrate.js');
} else {
    require('script-loader!./node_modules/jquery-migrate/dist/jquery-migrate.min.js');
}

import 'script-loader!./node_modules/jsviews/jsviews.min.js'
import 'script-loader!./node_modules/jquery-ui/dist/jquery-ui.min'
import 'script-loader!./node_modules/jquery-validation/dist/jquery.validate.min.js'
import 'script-loader!./node_modules/jquery-validation/dist/additional-methods.min.js'


import 'script-loader!./jquery.i18n.js'

import 'script-loader!././include/Legacy.js'
import './include/jsviews.extend'
require("./register")

jQuery.htmlPrefilter = function( html ) {
    return html;
};